import React, { Component } from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import configureStore from 'redux/store';

import Test from 'components/Test'
import Home from 'components/Home'
import Demo from 'components/Admin/Demo'
import Admin from 'components/Admin/Admin'
import Login from 'components/Admin/Login';
import PrivacyPolicy from 'components/PrivacyPolicy';
import NotFound from 'components/Admin/NotFound';

import Paths from 'paths'

import 'css/styles.css';
import 'css/login.css';
import 'css/grid.css';
import 'css/home.css';

class App extends Component{
    render() {
        return(
            <BrowserRouter>
                <Switch>
                    <Route exact path={Paths.PATH_HOME} component={Home} />

                    <Route exact path={Paths.PATH_PRIVACY_POLICY} component={PrivacyPolicy} />

                    <Route exact path={Paths.PATH_ADMIN_LOGIN} component={Login} />

                    <Route path={Paths.PATH_ADMIN_HOME} render={ (props) => 
                        <Provider store={configureStore()}>
                            <Admin {...props}/>
                        </Provider>
                    } />

                    <Route exact path={Paths.PATH_DEMO} render={ (props) => 
                        <Provider store={configureStore()}>
                            <Demo {...props}/>
                        </Provider>
                    } />

                    <Route exact path={'/test'} render={ (props) => 
                        <Provider store={configureStore()}>
                            <Test {...props}/>
                        </Provider>
                    } />
                    
                    <Route exact path={Paths.PATH_DEFAULT} component={NotFound} />
                </Switch>
            </BrowserRouter>
        )
    }
}

export default App